import { render, staticRenderFns } from "./ActionsCashRegister.vue?vue&type=template&id=6503a108"
import script from "./ActionsCashRegister.vue?vue&type=script&lang=js"
export * from "./ActionsCashRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports